import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgAvatar = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.625 10.125C7.625 11.2853 8.08594 12.3981 8.90641 13.2186C9.72688 14.0391 10.8397 14.5 12 14.5C13.1603 14.5 14.2731 14.0391 15.0936 13.2186C15.9141 12.3981 16.375 11.2853 16.375 10.125C16.375 8.96468 15.9141 7.85188 15.0936 7.03141C14.2731 6.21094 13.1603 5.75 12 5.75C10.8397 5.75 9.72688 6.21094 8.90641 7.03141C8.08594 7.85188 7.625 8.96468 7.625 10.125V10.125Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.7608 19.3967C17.006 18.6371 16.1084 18.0343 15.1197 17.623C14.1311 17.2116 13.0708 16.9999 12 16.9999C10.9291 16.9999 9.86888 17.2116 8.8802 17.623C7.89153 18.0343 6.99395 18.6371 6.23914 19.3967"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 12C2.625 14.4864 3.61272 16.871 5.37087 18.6291C7.12903 20.3873 9.5136 21.375 12 21.375C14.4864 21.375 16.871 20.3873 18.6291 18.6291C20.3873 16.871 21.375 14.4864 21.375 12C21.375 9.5136 20.3873 7.12903 18.6291 5.37087C16.871 3.61272 14.4864 2.625 12 2.625C9.5136 2.625 7.12903 3.61272 5.37087 5.37087C3.61272 7.12903 2.625 9.5136 2.625 12V12Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgAvatar.displayName = 'SvgAvatar';
export default SvgAvatar;
